import discardDateHeadersOption from './actions/discardDateHeadersOption';
import saveDateHeadersOption from './actions/saveDateHeadersOption';
import DateHeadersFull from './components/DateHeadersFull';
import isDateHeaderEnabled from './utils/isDateHeaderEnabled';
import isDateHeadersOptionDirty from './utils/isDateHeadersOptionDirty';
import { isFeatureEnabled } from 'owa-feature-flags';
import { Option, QuickSettingOrder } from 'owa-options-core';
import { OwaWorkload } from 'owa-workloads';
import * as React from 'react';

let DateHeadersOption: Option = {
    key: 'dateHeaders',
    titleStringKey: 'optionTitle_dateHeaders',
    searchTermsStringKey: 'optionTitle_dateHeaders',
    fullOptionFormSettings: {
        render: () => <DateHeadersFull />,
        isDirty: isDateHeadersOptionDirty,
        onSave: saveDateHeadersOption,
        onDiscard: discardDateHeadersOption,
    },
    quickOptionSettings: {
        rendering: {
            isToggleOn: isDateHeaderEnabled,
            onToggle: saveDateHeadersOption,
        },
        getOrder: () => QuickSettingOrder.DateHeaders,
        workloads: OwaWorkload.Mail,
        customTitle: 'options_dateHeaders_quick_label',
        isHidden: () => isFeatureEnabled('tri-density-controls'),
    },
};

export default DateHeadersOption;
